import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const ACTION_SHOW = gql`
  mutation ActionShowFun($contentGroupId: Int!, $targetSnippetId: Int!) {
    contentGroup {
      addAction(
        actionShow: {
          contentGroupId: $contentGroupId
          targetSnippetId: $targetSnippetId
        }
      ) {
        id
      }
    }
  }
`;

const ActionShow = ({
  contentGroupId,
  targetSnippetId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={ACTION_SHOW}>
    {(ActionShowFun, { loading, error, data }) => {
      const variables = {
        contentGroupId,
        targetSnippetId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentGroup.addAction.id);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={ActionShowFun}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

ActionShow.propTypes = {
  contentGroupId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  targetSnippetId: PropTypes.number.isRequired,
};

export default ActionShow;
